import Component from '../core/Component';
import Bloodhound from 'corejs-typeahead/dist/bloodhound';
// import 'typeahead.js'; import v app.js
import keycode from 'keycode'

export default class AutocompleteOld extends Component {

    constructor(element) {
        super(element)

        this.enabled = false
        this.typeahead = null

        this.$element = $(this.element)

        this.handleSelect = ::this.handleSelect
    }

    prepare() {
        this.element.addEventListener('keydown', ::this.handleKeydown)

        if (this.element.dataset.autocomplete) {
            this.enable()
        }
    }

    handleSelect(event, suggestion = {}) {
        if (!this.enabled) {
            return
        }

        if ('link' in suggestion) {
            window.location = suggestion.link;
        } else {
            this.$element.closest('form').submit()
        }
    }

    handleKeydown(event) {
        if (!this.enabled) {
            return
        }

        if (keycode(event.keyCode) === 'enter') {
            this.$element.closest('form').submit()
        }
    }

    enable(url = this.element.dataset.autocomplete) {
        if (this.enabled) {
            this.disable()
        }

        this.enabled = true

        const people = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: url,
                wildcard: '%QUERY'
            },
            limit: 5
        });
        people.initialize();

        this.$element.typeahead({
            hint: true,
            highlight: true,
            minLength: 1,
            classNames: {
                wrapper: 'AutocompleteOld',
                input: 'AutocompleteOld-input',
                hint: 'AutocompleteOld-hint',
                menu: 'AutocompleteOld-menu',
                dataset: 'AutocompleteOld-dataset',
                suggestion: 'AutocompleteOld-suggestion',
                empty: 'is-empty',
                open: 'is-open',
                cursor: 'is-active',
                highlight: 'is-highlighted',
                selectable: 'is-selectable'
            }
        }, {
            name: 'people',
            display: item => item.name,
            source: people.ttAdapter(),
            limit: 10,
            templates: {
                suggestion: data => `
                    <div class="photobook-AutocompleteItem">
                        <div class="photobook-AutocompleteItem-image">
                            <img src="${data.image}" width="46" height="46" alt="" class="photobook-AutocompleteItem-image">
                        </div>
                        <div class="photobook-AutocompleteItem-content">
                            <div class="photobook-AutocompleteItem-name">${data.name}</div>
                            <div class="photobook-AutocompleteItem-initials">${data.initials ? `(${data.initials})` : ''}</div>
                        </div>
                    </div>
                `
            }
        })

        this.$element.on('typeahead:select', this.handleSelect)
    }

    disable() {
        this.enabled = false
        this.$element.typeahead('destroy', 'people')
        this.$element.off('typeahead:select', this.handleSelect)
    }
}